/* eslint-disable no-undef */
/* eslint-disable react/prop-types */
import React from 'react';
// eslint-disable-next-line no-unused-vars
import { withRouter } from 'react-router';
import { motion } from 'framer-motion';
import Grid from '@material-ui/core/Grid';
import { Box, TextField } from '@material-ui/core';
import ResultItem from './ResultItem.js';
import PrintModal from './PrintModal';
import ColorButtonPurple from './ColorButtonPurple.js';
import ColorButtonWhite from './ColorButtonWhite.js';
import CopyRight from './CopyRight.js';
import ImageFukidashi2 from './images/img_fukidashi2.svg';
import jsPDF from 'jspdf';
import domtoimage from 'dom-to-image';
import ImageCodetta from './images/img_codetta.svg';
import firebase, { db } from '../Firebase.js';

const boxProps = {
  border: 1,
  borderColor: '#DADBDB',
};

let pdfDataUrl;

class Result extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isModalOpen: false, isEditMode: false, test: '' };
    this.handleToCloseModal = this.handleToCloseModal.bind(this);
    this.props.getLocalStrage();
    this.props.calc();
  }

  handleToEdit = () => {
    this.setState({ isEditMode: true });
  };
  handleToNotEdit = () => {
    this.addToDatabese();
    this.setState({ isEditMode: false });
    this.props.calc();
  };

  handleToPDF = () => {
    console.log(this.props.data.new_free);
    this.exportPdf();
    this.setState({ isModalOpen: true });
  };

  handleToCloseModal() {
    this.setState({ isModalOpen: false });
  }

  exportPdf() {
    const div = document.getElementById('pdf');
    //PDFの品質
    var scale = 3;
    const options = {
      background: 'white',
      height: div.clientHeight * scale * 1.15,
      width: div.clientWidth * scale,
      style: {
        transform: 'scale(' + scale + ')',
        transformOrigin: 'top left',
      },
    };

    domtoimage.toPng(div, options).then((dataUrl) => {
      pdfDataUrl = dataUrl;
    });
  }

  savePdf() {
    //Initialize JSPDF
    const pdf = new jsPDF('p', 'mm', 'a4'); // pdfを生成
    pdf.addImage(
      pdfDataUrl,
      'PNG',
      pdf.internal.pageSize.getWidth() * 0.02,
      pdf.internal.pageSize.getHeight() * 0.01,
      pdf.internal.pageSize.getWidth() * 0.96,
      pdf.internal.pageSize.getHeight() * 0.98
    );
    pdf.save('WorkPlaceSimulatorTrial');
  }

  //データベースに追加
  addToDatabese() {
    const docId = db.collection('work-palce-simulator-trial').doc().id;
    db.collection('work-palce-simulator-trial')
      .doc(docId)
      .set({
        docId: docId,
        createdAt: firebase.firestore.FieldValue.serverTimestamp(),
        action: '編集完了',
        name: '',
        company: '',
        busho: '',
        email: '',
        people: Number(this.props.data.office_people),
        area: Number(this.props.data.office_area),
        rent: Number(this.props.data.office_rent),
        kako_free: Number(this.props.data.kako_free),
        now_free: Number(this.props.data.now_free),
        new_free: Number(this.props.data.new_free),
        kako_shusha: Number(this.props.data.kako_shusha),
        now_shusha: Number(this.props.data.now_shusha),
        new_shusha: Number(this.props.data.new_shusha),
        kako_remotefeeP: this.props.data.kako_remotefeeP,
        now_remotefeeP: this.props.data.now_remotefeeP,
        new_remotefeeP: this.props.data.new_remotefeeP,
        kako_teatejukyu: Number(this.props.data.kako_teatejukyu),
        now_teatejukyu: Number(this.props.data.now_teatejukyu),
        new_teatejukyu: Number(this.props.data.new_teatejukyu),
      });
  }

  render() {
    let people;
    let area;
    let rent;
    let buttons;

    //編集モードじゃない時
    if (!this.state.isEditMode) {
      people = (
        <Box marginTop={1} textAlign="right" paddingLeft={8} paddingRight={8}>
          <h5 className="result_discripsion5">
            {this.props.data.office_people}
            <span> 人</span>
          </h5>
          <hr
            style={{
              color: '#333333',
              backgroundColor: '#333333',
              height: 0.5,
            }}
          />
        </Box>
      );
      area = (
        <Box marginTop={1} textAlign="right" paddingLeft={8} paddingRight={8}>
          <h5 className="result_discripsion5">
            {this.props.data.office_area}
            <span> ㎡</span>
          </h5>
          <hr
            style={{
              color: '#333333',
              backgroundColor: '#333333',
              height: 0.5,
            }}
          />
        </Box>
      );
      rent = (
        <Box marginTop={1} textAlign="right" paddingLeft={8} paddingRight={8}>
          <h5 className="result_discripsion5">
            {this.props.data.office_rent}
            <span> 万円/月</span>
          </h5>
          <hr
            style={{
              color: '#333333',
              backgroundColor: '#333333',
              height: 0.5,
            }}
          />
        </Box>
      );
      buttons = (
        <Box paddingTop={3} paddingBottom={3}>
          <Grid container justify="center">
            <Grid item xs={2}>
              <Box m={1} textAlign="right">
                <ColorButtonWhite size="large" variant="outlined" onClick={() => this.handleToEdit()}>
                  編集
                </ColorButtonWhite>
              </Box>
            </Grid>
            <Grid item xs={2}>
              <Box m={1} textAlign="left">
                <ColorButtonPurple
                  size="large"
                  variant="outlined"
                  onClick={() => {
                    this.handleToPDF();
                  }}
                >
                  PRINT
                </ColorButtonPurple>
              </Box>
            </Grid>
          </Grid>
        </Box>
      );
    } //編集モードの時
    else {
      people = (
        <Box position="relative" marginTop={1} textAlign="right" paddingLeft={8} paddingRight={8}>
          <img src={ImageFukidashi2} />
          <Box position="absolute" top={0} left={0} right={0} bottom={0} textAlign="center">
            <TextField
              style={{ width: 100 }}
              value={this.props.data.office_people}
              onChange={(e) => {
                this.props.handleOfficePeopleChange(e.target.value);
                this.props.calc();
              }}
              inputProps={{
                style: { fontSize: 15, textAlign: 'right', fontFamily: 'Noto Sans JP', fontWeight: 900 },
                min: 0,
              }}
              InputProps={{
                disableUnderline: true,
              }}
            ></TextField>
          </Box>
        </Box>
      );
      area = (
        <Box position="relative" marginTop={1} textAlign="right" paddingLeft={8} paddingRight={8}>
          <img src={ImageFukidashi2} />
          <Box position="absolute" top={0} left={0} right={0} bottom={0} textAlign="center">
            <TextField
              style={{ width: 100 }}
              value={this.props.data.office_area}
              onChange={(e) => {
                this.props.handleOfficeAreaChange(e.target.value);
                this.props.calc();
              }}
              inputProps={{
                style: { fontSize: 15, textAlign: 'right', fontFamily: 'Noto Sans JP', fontWeight: 900 },
                min: 0,
              }}
              InputProps={{
                disableUnderline: true,
              }}
            ></TextField>
          </Box>
        </Box>
      );
      rent = (
        <Box position="relative" marginTop={1} textAlign="right" paddingLeft={8} paddingRight={8}>
          <img src={ImageFukidashi2} />
          <Box position="absolute" top={0} left={0} right={0} bottom={0} textAlign="center">
            <TextField
              style={{ width: 100 }}
              value={this.props.data.office_rent}
              onChange={(e) => {
                this.props.handleOfficeRentChange(e.target.value);
                this.props.calc();
              }}
              inputProps={{
                style: { fontSize: 15, textAlign: 'right', fontFamily: 'Noto Sans JP', fontWeight: 900 },
                min: 0,
              }}
              InputProps={{
                disableUnderline: true,
              }}
            ></TextField>
          </Box>
        </Box>
      );
      buttons = (
        <Box paddingTop={4} paddingBottom={4}>
          <ColorButtonPurple size="large" variant="outlined" onClick={this.handleToNotEdit}>
            編集完了
          </ColorButtonPurple>
        </Box>
      );
    }

    let printModal;
    if (this.state.isModalOpen) {
      printModal = (
        <div>
          <PrintModal
            handleToCloseModal={this.handleToCloseModal}
            savePdf={this.savePdf}
            data={this.props.data}
            calc={this.props.calc}
          />
        </div>
      );
    }
    return (
      <div>
        <motion.div
          className="contents-inner"
          animate={{
            x: 0,
            opacity: 1,
          }}
          initial={{
            x: 100,
            opacity: 0,
          }}
          exit={{
            x: -100,
            opacity: 0,
          }}
          transition={{
            duration: 0.2,
          }}
        >
          <div id="pdf">
            <Box hidden={!this.state.isModalOpen} paddingLeft={2} paddingRight={2}>
              <Grid container alignItems="center">
                <Grid item xs={6}>
                  <Box textAlign="left">
                    <h1 className="pdf-tittle1">Work Place Simulator</h1>
                    <h5 className="pdf-tittle2">出社率とオフィススペースの割合に応じたシュミレーション</h5>
                  </Box>
                </Grid>
                <Grid item xs={3}>
                  <Box textAlign="left" marginLeft={3}>
                    <h5 className="pdf-tittle2">ワークプレイス・シュミレーター</h5>
                  </Box>
                </Grid>
                <Grid item xs={3}>
                  <Box textAlign="right">
                    <img src={ImageCodetta} height={100} />
                  </Box>
                </Grid>
              </Grid>
            </Box>

            <img src={ImageCodetta} hidden={true} />
            <Grid container>
              <Grid item xs={3}>
                <ResultItem
                  name="過去のオフィス"
                  nameEN="Before covid-19"
                  discript="covid-19以前のオフィス"
                  dataName1="フリーアドレス率"
                  dataName2="固定席率"
                  free={this.props.data.kako_free}
                  kotei={this.props.data.kako_kotei}
                  shusha={this.props.data.kako_shusha}
                  remote={this.props.data.kako_remote}
                  area={this.props.data.kako_area}
                  officefee={this.props.data.kako_officefee}
                  officefeeP={this.props.data.kako_officefeeP}
                  remotefeeP={this.props.data.kako_remotefeeP}
                  teatejyukyu={this.props.data.kako_teatejukyu}
                  teatetotal={this.props.data.kako_teatetotal}
                  area_zogen=""
                  officefee_zogen=""
                  officefeeP_zogen=""
                  fillColor="#BBBBBB"
                  isEditMode={false}
                  isKako={true}
                />
              </Grid>

              <Grid item xs={3}>
                <ResultItem
                  name="現在のオフィス"
                  nameEN="Under covid-19"
                  discript="covid-19影響下の現在のオフィス"
                  free={this.props.data.now_free}
                  kotei={this.props.data.now_kotei}
                  shusha={this.props.data.now_shusha}
                  remote={this.props.data.now_remote}
                  area={this.props.data.now_area}
                  officefee={this.props.data.now_officefee}
                  officefeeP={this.props.data.now_officefeeP}
                  remotefeeP={this.props.data.now_remotefeeP}
                  teatejyukyu={this.props.data.now_teatejukyu}
                  teatetotal={this.props.data.now_teatetotal}
                  area_zogen={this.props.data.now_area_zogen}
                  officefee_zogen={this.props.data.now_officefee_zogen}
                  officefeeP_zogen={this.props.data.now_officefeeP_zogen}
                  fillColor="#5BB5A4"
                  isEditMode={this.state.isEditMode}
                  handleFreeChange={(e) => this.props.handleNowFreeChange(e)}
                  handleKoteiChange={(e) => this.props.handleNowKoteiChange(e)}
                  handleRemoteChange={(e) => this.props.handleNowRemoteChange(e)}
                  handleShushaChange={(e) => this.props.handleNowShushaChange(e)}
                  handelRemoteFeeChange={(e) => this.props.handleNowRemoteFeePChange(e)}
                  handleTeateJukyuChange={(e) => this.props.handleNowTeateJukyuChange(e)}
                  calc={this.props.calc}
                  isKako={false}
                />
              </Grid>
              <Grid item xs={3}>
                <ResultItem
                  name="今後のオフィス"
                  nameEN="New normal"
                  discript="働き方を改革した今後のオフィス"
                  free={this.props.data.new_free}
                  kotei={this.props.data.new_kotei}
                  shusha={this.props.data.new_shusha}
                  remote={this.props.data.new_remote}
                  area={this.props.data.new_area}
                  officefee={this.props.data.new_officefee}
                  officefeeP={this.props.data.new_officefeeP}
                  remotefeeP={this.props.data.new_remotefeeP}
                  teatejyukyu={this.props.data.new_teatejukyu}
                  teatetotal={this.props.data.new_teatetotal}
                  area_zogen={this.props.data.new_area_zogen}
                  officefee_zogen={this.props.data.new_officefee_zogen}
                  officefeeP_zogen={this.props.data.new_officefeeP_zogen}
                  fillColor="#5BB5A4"
                  isEditMode={this.state.isEditMode}
                  handleFreeChange={(e) => this.props.handleNewFreeChange(e)}
                  handleKoteiChange={(e) => this.props.handleNewKoteiChange(e)}
                  handleRemoteChange={(e) => this.props.handleNewRemoteChange(e)}
                  handleShushaChange={(e) => this.props.handleNewShushaChange(e)}
                  handelRemoteFeeChange={(e) => this.props.handleNewRemoteFeePChange(e)}
                  handleTeateJukyuChange={(e) => this.props.handleNewTeateJukyuChange(e)}
                  calc={this.props.calc}
                  isKako={false}
                />
              </Grid>
              <Grid item xs={3}>
                <ResultItem
                  name="codettaアイデア"
                  nameEN="Future"
                  discript="イノベーションを主目的としたオフィス"
                  free={this.props.data.future_free}
                  kotei={this.props.data.future_kotei}
                  shusha={this.props.data.future_shusha}
                  remote={this.props.data.future_remote}
                  area={this.props.data.future_area}
                  officefee={this.props.data.future_officefee}
                  officefeeP={this.props.data.future_officefeeP}
                  remotefeeP={this.props.data.future_remotefeeP}
                  teatejyukyu={this.props.data.future_teatejukyu}
                  teatetotal={this.props.data.future_teatetotal}
                  area_zogen={this.props.data.future_area_zogen}
                  officefee_zogen={this.props.data.future_officefee_zogen}
                  officefeeP_zogen={this.props.data.future_officefeeP_zogen}
                  fillColor="#5BB5A4"
                  isEditMode={false}
                  isKako={false}
                />
              </Grid>
            </Grid>

            <Box
              display="flex"
              justifyContent="center"
              minHeight={120}
              {...boxProps}
              marginTop={3}
              marginLeft={2}
              marginRight={2}
              marginBottom={3}
            >
              <Grid container alignItems="center">
                <Grid item xs={3}>
                  <h2 className="result_tittle">基本情報</h2>
                </Grid>
                <Grid item xs={3}>
                  <h5 className="result_discripsion2">社員数</h5>
                  {people}
                </Grid>
                <Grid item xs={3}>
                  <h5 className="result_discripsion2">現状のオフィス面積</h5>
                  {area}
                </Grid>
                <Grid item xs={3}>
                  <h5 className="result_discripsion2">現状のオフィス賃料</h5>
                  {rent}
                </Grid>
              </Grid>
            </Box>

            <Box hidden={!this.state.isModalOpen}>
              <p className="pdf-footer">
                ワークプイレス・シュミレーター、株式会社ワークパス（https://workpath.co.jp）の提供する、働き方に合わせ、最適なオフィス規模を提案するサービスです。
                <br />
                表示された、数値はあくまでも目安であり、不動産相場や建築コストの変動で前後します。
              </p>
              <p className="pdf-copyright">Copyright(C) WorkPath Inc. All Rights Reserved.</p>
            </Box>
          </div>

          {buttons}

          <div id="pdf">
            <CopyRight />
          </div>
        </motion.div>

        {printModal}
      </div>
    );
  }
}

export default Result;
